/**
 * @file Entrypoint for whiteboard (Sandbox) page.
 *
 * Passes `errorTrackingSource: 'sandbox'` explicitly so the tag is set even
 * when the HTML layout attribute is not `"whiteboard"` (e.g. breakout pages
 * render `data-layout="matrix"`). See PRO-30444.
 */

import { SANDBOX_SOURCE_TAG_VALUE } from '@@/bits/error_tracker'
import { setupSurfaceVueApp } from '@@/bits/surface_page'
import Whiteboard from '@@/vuecomponents/Whiteboard.vue'

setupSurfaceVueApp(Whiteboard, { errorTrackingSource: SANDBOX_SOURCE_TAG_VALUE })
